import globalFilters from '../../filters';
let months = ['OCA', 'ŞUB', 'MAR', 'NİS', 'MAY', 'HAZ', 'TEM', 'AĞU', 'EYL', 'EKİ', 'KAS', 'ARA'];
let monthsEn = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AGU', 'SEP', 'OCT', 'NOV', 'DEC'];
import uuidV4 from 'uuid/v4';
import _ from 'lodash';

months = localStorage.getItem('locale') === 'tr' ? months : monthsEn;
export default {
    data() {
        return {
            pieChartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Toplam Karbon Emisyonu',
                        labels: [],
                        hoverBorderWidth: [],
                        hoverBorderColor: [],
                        backgroundColor: [],
                        data: []
                    }
                ]
            },
            pieChartOptions: {
                layout: {
                    padding: {
                        top: 100,
                        left: 10,
                        bottom: 10,
                        right: 10
                    }
                },
                responsive: true,
                title: {
                    display: false,
                    text: 'Toplam Karbon Emisyonları',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            let label = ' ';
                            label +=
                                data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] ||
                                '';
                            if (label) {
                                label += ': ';
                            }
                            let total = data.datasets[tooltipItem.datasetIndex].data.reduce(
                                (accumulator, currentValue) => accumulator + currentValue
                            );
                            let ratio = (
                                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] /
                                total *
                                100
                            ).toFixed(1);
                            return label + globalFilters.localizedRatioText(ratio, this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint'
                },
                legend: {
                    position: 'right',
                    labels: {
                        padding: 20,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function(e, legendItem) {
                        let segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return {e, legendItem};
                    }
                }
            },
            colorPalette: [
                'rgba(250,164,58,1)',
                'rgba(96,189,104,1)',
                'rgba(247,82,133,1)',
                'rgba(93,165,218,1)',
                'rgba(222,207,63,1)',
                'rgba(178,118,178,1)',
                'rgba(77,77,77,1)',
                'rgba(178,145,47,1)',
                'rgba(222,207,63,1)',
                'rgba(241,88,84,1)'
            ],
            colorPaletteHalfOpacity: [
                'rgba(250,164,58,0.5)',
                'rgba(96,189,104,0.5)',
                'rgba(247,82,133,0.5)',
                'rgba(93,165,218,0.5)',
                'rgba(222,207,63,0.5)',
                'rgba(178,118,178,0.5)',
                'rgba(77,77,77,0.5)',
                'rgba(178,145,47,0.5)',
                'rgba(222,207,63,0.5)',
                'rgba(241,88,84,0.5)'
            ],
            consumptions: {}
        };
    },
    methods: {
        generateBarChartOptions() {
            this.chartDataTypes.forEach((dataType, index) => {
                let found = _.find(this.$store.state.sourceTypes, {id: dataType});
                let unit = null;
                switch (_.get(found, 'name')){
                    case 'blueWater':
                        unit = 'm³'
                        break;
                    case 'electricity':
                        unit = 'kWh'
                        break;
                    case 'naturalGas':
                        unit = 'm³'
                        break;
                }
                this.$set(this.consumptions, dataType, {
                    title: this.$t(found.name) + '  ' + this.$t('consumptions'),
                    current: [],
                    previous: [],
                    chartId: uuidV4(),
                    barChartData: {
                        datasets: [
                            {
                                label: this.$store.state.year - 1,
                                mainTitle: this.$t(found.name),
                                backgroundColor: this.colorPaletteHalfOpacity[index % 3],
                                hoverBackgroundColor: this.colorPaletteHalfOpacity[index % 3],
                                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                                yAxisID: 'a',
                                type: 'bar',
                                unit: unit
                            },
                            {
                                label: this.$store.state.year,
                                mainTitle: this.$t(found.name),
                                backgroundColor: this.colorPalette[index % 3],
                                hoverBackgroundColor: this.colorPalette[index % 3],
                                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                                yAxisID: 'a',
                                type: 'bar',
                                unit: unit
                            }
                        ]
                    },
                    barChartOptions: {
                        steppedLine: false,
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            position: 'bottom',
                            display: false
                        },
                        title: {
                            display: false
                        },
                        barValueSpacing: 20,
                        scales: {
                            yAxes: [
                                {
                                    id: 'a',
                                    display: true,
                                    scaleLabel: {
                                        display: true,
                                        labelString: unit
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        stepSize: 100000,
                                        display: true,
                                        callback: tick => {
                                            return globalFilters.parseNumber(
                                                tick,
                                                'number',
                                                this.locale
                                            );
                                        }
                                    },
                                    gridLines: {
                                        display: false,
                                        color: 'rgba(154, 167, 177, 0.5)',
                                        lineWidth: 1
                                    }
                                }
                            ],
                            xAxes: [
                                {
                                    type: 'category',
                                    categoryPercentage: 0.5,
                                    maxBarThickness: 20,
                                    ticks: {
                                        autoSkip: false
                                    },
                                    labels: months,
                                    gridLines: {
                                        display: false
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItem, data) => {
                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    label += globalFilters.parseNumber(
                                        tooltipItem.yLabel,
                                        'float',
                                        this.$store.state.locale
                                    );
                                    label += ` ${unit}`;
                                    return label;
                                }
                            }
                        }
                    }
                });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/Dashboard/mixin.js